import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const Fifa = () => {
  return (
    <SportsLayoutComp name={'FIFA'}/>
  )
}

export default Fifa